import { render, staticRenderFns } from "./checkQuestion.vue?vue&type=template&id=344adeca&scoped=true&"
import script from "./checkQuestion.vue?vue&type=script&lang=js&"
export * from "./checkQuestion.vue?vue&type=script&lang=js&"
import style0 from "./checkQuestion.vue?vue&type=style&index=0&id=344adeca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344adeca",
  null
  
)

export default component.exports